import React, { useContext } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import Context from "../EventsProvider";
import timezones from "../model/timezones";

//style rules
import { Typography } from "../../../styles";

const CardMeta = ({location, startDate, rawDate}) => {
	const {data: {language},} = useContext(Context);


	const renderLocation = () => {
		if (!location) return null;
		return <CardMetaText>{ location } | </CardMetaText>;
	}

	const renderStartDate = () => {
		if (!startDate) return null;

		if (language !== "en") {
			if (!rawDate) return null;

			const startDateFrench = new Date(rawDate).toLocaleString('fr-FR', { month: 'long', day: 'numeric', year: 'numeric', });
			const hour = new Date(rawDate).toLocaleString('fr-FR', { hour: 'numeric', minute: 'numeric', }).split(':');
			const timezone = startDate.split(' ');
			const timeZoneKey = timezone[timezone.length - 1];
			
			return <CardMetaText>{ `${startDateFrench}, ${hour[0]}h ${hour[1]} ${timezones.fr[timeZoneKey]}` }</CardMetaText>;
		}

		return <CardMetaText>{ startDate }</CardMetaText>;
	}
	
	return  (
		<>
			{renderLocation()}
			{renderStartDate()}
		</>
	);
}

CardMeta.propTypes = {
	location: PropTypes.string,
	startDate: PropTypes.string,
	rawDate: PropTypes.string,
};

export default CardMeta;

const CardMetaText = styled.span`
	font-size: 1.3rem;
	font-weight: ${Typography.fontWeight.medium};
	line-height: 1.5rem;

	&.week-day {
		text-transform: capitalize;
	}
`;
